<template>
    <div class="col-12 gm-buy-page">
        <div class="card card-outline card-secondary">

            <div class="card-header">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div>
                        <h3>
                            Gastos recurrentes</h3>
                        <small class="text-muted d-block mt-1">
                            Consulta, administra pagos y controla los contratos digitales.
                        </small>
                    </div>
                    <div class="card-tools mt-2 mt-md-0">
                        <button class="btn m-1 btn-sm btn-outline-success" @click="exportData()">
                            <i class="fa-regular fa-file-excel mr-1"></i> Exportar Excel
                        </button>
                        <button class="btn m-1 btn-sm btn-primary" @click="editBuy()" v-can="'add_buy'">
                            <i class="fa-solid fa-plus mr-1"></i> Nuevo gasto
                        </button>
                    </div>
                </div>
            </div>

            <section class="gm-buy-filters" aria-label="Filtros de gastos">
                <div class="gm-buy-section-label"><i class="fa-solid fa-filter mr-2"></i> Filtros</div>
                <div class="row">
                    <div class="col-lg-5 col-md-8 gm-filter-col">
                        <label for="gm-search-name">Buscar gasto</label>
                        <input id="gm-search-name" class="form-control" v-debounce:1s="list" v-model="name"
                            placeholder="Concepto, proveedor o descripción">
                    </div>
                    <div class="col-lg-2 col-md-4 gm-filter-col">
                        <label for="gm-search-id">ID</label>
                        <input id="gm-search-id" class="form-control" v-debounce:1s="list" v-model="idS"
                            placeholder="Ej. 142">
                    </div>
                    <div class="col-lg-5 col-md-6 gm-filter-col">
                        <label>Propiedad</label>
                        <select class="form-control" v-model="search.building_id">
                            <option value="">Todas las propiedades</option>
                            <option v-for="building in catalogue.buildings" :key="building.id" :value="building.id">{{
                                building.name }}</option>
                        </select>
                    </div>
                    <div class="col-lg-4 col-md-6 gm-filter-col">
                        <label>Empresa</label>
                        <select class="form-control" v-model="search.company_id">
                            <option value="">Todas las empresas</option>
                            <option v-for="company in catalogue.companies_buildings" :key="company.id"
                                :value="company.id">
                                {{ company.name }}</option>
                        </select>
                    </div>
                    <div class="col-lg-4 col-md-6 gm-filter-col" v-if="authUser.organization_charts_id != 2">
                        <label>Usuario</label>
                        <select class="form-control" v-model="search.user_id">
                            <option value="">Todos los usuarios</option>
                            <option v-for="user in catalogue.users_profile" :key="user.id" :value="user.id">{{ user.name
                                }}
                                {{ user.last_name }}</option>
                        </select>
                    </div>
                    <div class="col-lg-4 col-md-6 gm-filter-col">
                        <label>Categoría</label>
                        <select class="form-control" v-model="search.concept_id">
                            <option value="">Todas las categorías</option>
                            <option v-for="concept in catalogue.concepts" :key="concept.id" :value="concept.id">{{
                                concept.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="gm-buy-quick-filters">
                    <button type="button" class="gm-buy-chip" :class="{ 'is-active': !!search.requires_contract }"
                        :aria-pressed="!!search.requires_contract"
                        @click="search.requires_contract = search.requires_contract ? '' : 1">
                        <i class="fa-solid fa-file-contract"></i> Requiere contrato
                    </button>
                    <button type="button" class="gm-buy-chip" :class="{ 'is-active': !!search.no_repse_required }"
                        :aria-pressed="!!search.no_repse_required"
                        @click="search.no_repse_required = search.no_repse_required ? '' : 1">
                        <i class="fa-solid fa-shield-halved"></i> Requiere REPSE
                    </button>
                    <button type="button" class="gm-buy-chip" :class="{ 'is-active': !!search.has_overdue_payment }"
                        :aria-pressed="!!search.has_overdue_payment"
                        @click="search.has_overdue_payment = search.has_overdue_payment ? '' : 1">
                        <i class="fa-solid fa-clock"></i> Pagos pendientes
                    </button>
                    <button type="button" class="gm-buy-clear" @click="clearBuyFilters">
                        <i class="fa-solid fa-rotate-left mr-1"></i> Limpiar filtros
                    </button>
                </div>
            </section>

            <div class="gm-buy-stats">
                <div class="gm-buy-stat gm-buy-stat--slate">
                    <span class="gm-buy-stat__icon"><i class="fa-solid fa-layer-group"></i></span>
                    <div><small>RESULTADOS</small><strong>{{ buys.total || 0 }}</strong></div>
                </div>
                <div class="gm-buy-stat gm-buy-stat--green">
                    <span class="gm-buy-stat__icon"><i class="fa-solid fa-circle-check"></i></span>
                    <div><small>CONTRATOS RECIBIDOS *</small><strong>{{ buyPageReceivedContracts }}</strong></div>
                </div>
                <div class="gm-buy-stat gm-buy-stat--amber">
                    <span class="gm-buy-stat__icon"><i class="fa-solid fa-link"></i></span>
                    <div><small>ENLACES ACTIVOS *</small><strong>{{ buyPageActiveLinks }}</strong></div>
                </div>
                <div class="gm-buy-stat gm-buy-stat--blue">
                    <span class="gm-buy-stat__icon"><i class="fa-solid fa-file-invoice-dollar"></i></span>
                    <div><small>MONTO MOSTRADO *</small><strong>{{ buyPageAmount | toCurrency }}</strong></div>
                </div>
            </div>
            <div class="gm-buy-stats-note">* Indicadores calculados sobre los registros de esta página.</div>

            <section class="gm-buy-results">
                <div class="gm-buy-results-head">
                    <div>
                        <h3>Listado de gastos</h3>
                        <p>Gestiona operaciones, pagos y documentos desde un mismo lugar.</p>
                    </div>
                    <div class="gm-buy-segment" role="group" aria-label="Estado del gasto">
                        <button type="button" :class="{ active: Number(search.status) === 1 }"
                            @click="search.status = 1">Activos</button>
                        <button type="button" :class="{ active: Number(search.status) === 2 }"
                            @click="search.status = 2">Terminados</button>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered text-center text-sm gm-buy-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th style="width: 50%;">Datos del gasto recurrente</th>
                                <th>Fecha</th>
                                <th style="width: 140px;">Monto</th>
                                <th style="width: 140px;">Pagado</th>
                                <th style="width: 140px;">Por pagar</th>
                                <th>Opciones</th>
                            </tr>
                        </thead>
                        <tbody v-if="load">
                            <tr>
                                <td align="center" colspan="7">
                                    <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                    <h5>Cargando</h5>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="buys.total > 0">
                            <tr :class="buy.authorization_user_id ? 'bg-info' : ''" v-for="(buy, index) in buys.data"
                                :key="index">
                                <td>
                                    {{ buy.id }}
                                    <div class=" mt-3" v-if="buy.require_contract == 0 && buy.file == null">
                                        <i class="fa-solid fa-file-circle-exclamation text-warning fa-xl  fa-fade"></i>
                                    </div>
                                    <div class=" mt-3" v-if="buy.no_repse_required == 0 && buy.repse == null">
                                        <i class="fa-solid fa-file-circle-exclamation text-primary fa-xl  fa-fade"></i>
                                    </div>
                                    <div class=" mt-3" v-if="buy.has_overdue_payment">
                                        <i class="fa-solid fa-file-circle-exclamation text-success fa-xl  fa-fade"></i>
                                    </div>
                                </td>
                                <td class="text-left">
                                    <!-- Compra padre -->
                                    <strong>Gasto recurrente padre:</strong>
                                    <router-link v-if="buy.buy" :to="`/buy/form/${buy.buy.id}`">Gasto recurrente #{{
                                        buy.buy.id
                                        }}</router-link>
                                    <span v-else>N/A</span>
                                    <br>
                                    <!-- Recurrencia -->
                                    <strong>Recurrencia:</strong>
                                    <span v-if="buy.payments_recurring"> {{ buy.payments_recurring.name }}</span>
                                    <span v-else>Sin Recurrencia</span>
                                    <br>
                                    <!-- Propiedad -->
                                    <strong>Propiedad:</strong>
                                    <span v-if="buy.building"> {{ buy.building.name }}</span>
                                    <span v-else>Sin propiedad</span>
                                    <br>
                                    <!-- Indiviso -->
                                    <strong>Indiviso:</strong>
                                    <span v-if="buy.departament"> Número {{ buy.departament.number }} / Piso {{
                                        buy.departament.level }}</span>
                                    <span v-else>N/A</span>
                                    <br>
                                    <!-- Empresa -->
                                    <strong>Empresa:</strong>
                                    <span v-if="buy.company"> {{ buy.company.name }} </span>
                                    <span v-else>N/A</span>
                                    <br>
                                    <!-- concepto -->
                                    <strong>Concepto:</strong>
                                    <span v-if="buy.concept"> {{ buy.concept.name }}</span>
                                    <span v-else>Sin concepto</span>
                                    <br>
                                    <!-- razón social -->
                                    <strong>Razón social:</strong>
                                    <span v-if="buy.user">
                                        <span v-if="buy.user.bill_data.length > 0">
                                            {{ buy.user.bill_data[0].business_name }}
                                        </span>
                                        <span v-else>Sin razón</span>
                                    </span>
                                    <span v-else>Sin razón</span>
                                    <br>
                                    <!-- Proveedor -->
                                    <strong>Usuario</strong>
                                    <span v-if="buy.user"> {{ buy.user.name }} {{ buy.user.last_name }}</span>
                                    <span v-else>Sin usuario</span>
                                    <br>
                                    <!-- Requiere contrato -->
                                    <strong>Requiere Contrato:</strong>
                                    <span v-if="buy.require_contract == 1"> SI</span>
                                    <span v-else>NO</span>
                                    <br>
                                    <!-- No servicio -->
                                    <div v-if="buy.no_service">
                                        <strong>No servicio: </strong><br>
                                        <span>{{ buy.no_service }}</span>
                                        <br>
                                    </div>
                                    <div>
                                        <strong>Autorizado por: </strong><br>
                                        <div class="badge p-1 badge-success ml-1" v-show="buy.users_approved.length > 0"
                                            v-for="(validator, index) in buy.users_approved" :key="index">
                                            <span v-if="validator.user">{{ validator.user?.name }} {{
                                                validator.user?.last_name }}</span>
                                            <span v-else>Usuario desvinculado</span>
                                        </div>
                                        <div v-show="buy.users_approved.length == 0">
                                            <span>Ninguno</span>
                                        </div>
                                    </div>
                                    <button @click="viewPay(buy.id)" type="button"
                                        class="btn btn-sm  m-1 btn-outline-secondary ">
                                        <i class="fa-solid fa-eye"></i> Ver
                                    </button>
                                    <button @click="editBuy(buy)" v-can="'edit_buy'"
                                        class="btn btn-outline-primary m-1 btn-sm">
                                        <i class="fas fa-edit "> </i> Editar
                                    </button>
                                    <button type="button" @click="deleted(buy.id)" v-can="'deleted_buy'"
                                        class="btn-outline-danger btn m-1 btn-sm ">
                                        <i class="fa fa-trash"></i> Eliminar
                                    </button>
                                </td>
                                <td>
                                    <span v-if="buy.star_date"> {{ buy.star_date | toDateTime }} </span>
                                    <span v-if="buy.end_date"> - {{ buy.end_date | toDateTime }} </span>
                                </td>
                                <td class="text-right">
                                    {{ buy.amount | toCurrency }}
                                </td>
                                <td class="text-right">
                                    {{ paysCheks(buy.checks) | toCurrency }}
                                </td>
                                <td class="text-right">
                                    {{ buy.amount - paysCheks(buy.checks) | toCurrency }}
                                </td>
                                <td>
                                    <button type="button" @click="approve(buy.id)" v-if="shouldShowAuthorizeButton(buy)"
                                        class="btn-outline-warning btn m-1 btn-sm ">
                                        <i class="fa fa-check"></i> Autorizar
                                    </button>
                                    <button type="button" v-if="buy.checks.length > 0" @click="showCheck(buy.checks)"
                                        class="btn m-1 btn-outline-secondary btn btn-sm ">
                                        <i class="fa-solid fa-hand-holding-dollar"></i> Pagos
                                    </button>
                                    <button type="button" v-if="buy.buys.length > 0" @click="showBuysRelation(buy)"
                                        class="btn m-1 btn-outline-info btn btn-sm ">
                                        <i class="fa-solid fa-business-time"></i> Ver compra
                                    </button>
                                    <button type="button" @click="changeStatus(buy)" v-can="'deleted_buy'"
                                        :class="buy.status == 1 ? 'btn-outline-danger' : 'btn-outline-success'"
                                        class=" btn m-1 btn-sm ">
                                        <span v-if="buy.status == 1">
                                            <i class="fa-solid fa-power-off"></i> Terminar
                                        </span>
                                        <span v-else>
                                            <i class="fa-solid fa-power-off"></i> Activar
                                        </span>
                                    </button>
                                    <button @click="createFrom(buy)" type="button"
                                        class="btn btn-sm  m-1 btn-outline-secondary ">
                                        <i class="fa-solid fa-file-circle-plus"></i> Generar compra
                                    </button>
                                    <button @click="showIncreases(buy)" type="button"
                                        class="btn btn-sm  m-1 btn-outline-secondary ">
                                        <i class="fa-solid fa-file-circle-plus"></i> Aumentos
                                    </button>
                                    <!-- CONTRATOS DIGITALES: misma interfaz que Budget -->
                                    <div class="gm-contract-list" v-if="buy.applies_to_service || buy.applies_to_work">
                                        <div v-if="shouldShowContract(buy, 1)" class="gm-contract-item">
                                            <div class="gm-contract-item__head">
                                                <span class="gm-contract-item__icon"><i
                                                        class="fa-solid fa-file-contract"></i></span>
                                                <div class="gm-contract-item__name"><strong>Contrato de
                                                        servicio</strong><small>Documento contractual</small></div>
                                                <span :class="contractBadgeClass(getContract(buy, 1))">{{
                                                    contractStatusLabel(getContract(buy, 1)) }}</span>
                                            </div>
                                            <div v-if="getContract(buy, 1) && isContractSigned(getContract(buy, 1))"
                                                class="gm-contract-item__signed">
                                                <i class="fa-solid fa-circle-check mr-1"></i>
                                                Firmado por {{ signerForContract(getContract(buy, 1)) || 'el proveedor'
                                                }}
                                                <small v-if="signedDateForContract(getContract(buy, 1))">{{
                                                    formatContractDate(signedDateForContract(getContract(buy, 1)))
                                                    }}</small>
                                            </div>
                                            <div v-if="hasUploadedContract(getContract(buy, 1))"
                                                class="gm-contract-item__received">
                                                <div class="gm-contract-item__received-icon"><i
                                                        class="fa-solid fa-file-circle-check"></i></div>
                                                <div class="gm-contract-item__received-body">
                                                    <strong>PDF firmado recibido</strong>
                                                    <span
                                                        :title="uploadedContractFile(getContract(buy, 1)).original_name">{{
                                                            uploadedContractFile(getContract(buy, 1)).original_name
                                                        }}</span>
                                                    <small>Enviado por el proveedor · {{
                                                        formatContractDate(uploadedContractFile(getContract(buy,
                                                            1)).received_at) }}</small>
                                                </div>
                                                <!-- <span class="gm-contract-item__review-label">En revisión</span> -->
                                            </div>
                                            <div class="gm-contract-item__actions">
                                                <a target="_blank" rel="noopener noreferrer"
                                                    :href="`${globalUrlFiles}/contract-service/pdf/buy/${buy.id}`"
                                                    class="btn btn-outline-secondary btn-sm"><i
                                                        class="fa-regular fa-file-pdf mr-1"></i> Vista previa</a>
                                                <button
                                                    v-if="getContract(buy, 1) && isContractSigned(getContract(buy, 1))"
                                                    type="button" class="btn btn-success btn-sm"
                                                    @click="viewSignedContract(getContract(buy, 1))"><i
                                                        class="fa-solid fa-file-circle-check mr-1"></i> Ver PDF
                                                    firmado</button>
                                                <button v-if="canGenerateContractLink(getContract(buy, 1))"
                                                    type="button" class="btn btn-outline-primary btn-sm"
                                                    @click="generateContractLink(buy, 1, 2)"><i
                                                        class="fa-solid fa-link mr-1"></i> {{ getContract(buy, 1) ?
                                                            'Nuevo enlace' : 'Generar enlace' }}</button>
                                                <button
                                                    v-if="getContract(buy, 1) && hasActiveLink(getContract(buy, 1)) && !isContractSigned(getContract(buy, 1)) && getContract(buy, 1).latest_request.signature_url"
                                                    type="button" class="btn btn-outline-info btn-sm"
                                                    @click="viewContractLink(getContract(buy, 1))"><i
                                                        class="fa-solid fa-eye mr-1"></i> Ver enlace</button>

                                                <!-- Enviar correo: solo después de generar el enlace -->
                                                <contract-email-button v-if="
                                                    getContract(buy, 1) &&
                                                    hasActiveLink(getContract(buy, 1)) &&
                                                    !isContractSigned(getContract(buy, 1)) &&
                                                    getContract(buy, 1).latest_request &&
                                                    getContract(buy, 1).latest_request.signature_url
                                                " :contract="getContract(buy, 1)" :source-type="2" :contract-type="1"
                                                    :provider-email="buy.user ? buy.user.email : ''"
                                                    @sent="list(page)" />

                                                <button v-if="hasUploadedContract(getContract(buy, 1))" type="button"
                                                    class="btn btn-outline-success btn-sm"
                                                    @click="viewUploadedContract(getContract(buy, 1))">
                                                    <i class="fa-solid fa-file-pdf mr-1"></i> Ver PDF recibido
                                                </button>

                                                <button v-if="canCancelReceivedContract(getContract(buy, 1))"
                                                    type="button"
                                                    class="btn btn-outline-danger btn-sm gm-contract-cancel-button"
                                                    @click="cancelReceivedContract(getContract(buy, 1))">
                                                    <i class="fa-solid fa-ban mr-1"></i>
                                                    {{ isContractSigned(getContract(buy, 1)) ? 'Cancelar firma' :
                                                        'Cancelar archivo' }}
                                                </button>
                                            </div>
                                        </div>
                                        <div v-if="shouldShowContract(buy, 2)" class="gm-contract-item">
                                            <div class="gm-contract-item__head">
                                                <span class="gm-contract-item__icon"><i
                                                        class="fa-solid fa-file-signature"></i></span>
                                                <div class="gm-contract-item__name"><strong>Contrato de
                                                        obra</strong><small>Documento contractual</small></div>
                                                <span :class="contractBadgeClass(getContract(buy, 2))">{{
                                                    contractStatusLabel(getContract(buy, 2)) }}</span>
                                            </div>
                                            <div v-if="getContract(buy, 2) && isContractSigned(getContract(buy, 2))"
                                                class="gm-contract-item__signed">
                                                <i class="fa-solid fa-circle-check mr-1"></i>
                                                Firmado por {{ signerForContract(getContract(buy, 2)) || 'el proveedor'
                                                }}
                                                <small v-if="signedDateForContract(getContract(buy, 2))">{{
                                                    formatContractDate(signedDateForContract(getContract(buy, 2)))
                                                    }}</small>
                                            </div>
                                            <div v-if="hasUploadedContract(getContract(buy, 2))"
                                                class="gm-contract-item__received">
                                                <div class="gm-contract-item__received-icon"><i
                                                        class="fa-solid fa-file-circle-check"></i></div>
                                                <div class="gm-contract-item__received-body">
                                                    <strong>PDF firmado recibido</strong>
                                                    <span
                                                        :title="uploadedContractFile(getContract(buy, 2)).original_name">{{
                                                            uploadedContractFile(getContract(buy, 2)).original_name
                                                        }}</span>
                                                    <small>Enviado por el proveedor · {{
                                                        formatContractDate(uploadedContractFile(getContract(buy,
                                                            2)).received_at) }}</small>
                                                </div>
                                                <!-- <span class="gm-contract-item__review-label">En revisión</span> -->
                                            </div>
                                            <div class="gm-contract-item__actions">
                                                <a target="_blank" rel="noopener noreferrer"
                                                    :href="`${globalUrlFiles}/contract-work/pdf/buy/${buy.id}`"
                                                    class="btn btn-outline-secondary btn-sm"><i
                                                        class="fa-regular fa-file-pdf mr-1"></i> Vista previa</a>
                                                <button
                                                    v-if="getContract(buy, 2) && isContractSigned(getContract(buy, 2))"
                                                    type="button" class="btn btn-success btn-sm"
                                                    @click="viewSignedContract(getContract(buy, 2))"><i
                                                        class="fa-solid fa-file-circle-check mr-1"></i> Ver PDF
                                                    firmado</button>
                                                <button v-if="canGenerateContractLink(getContract(buy, 2))"
                                                    type="button" class="btn btn-outline-primary btn-sm"
                                                    @click="generateContractLink(buy, 2, 2)"><i
                                                        class="fa-solid fa-link mr-1"></i> {{ getContract(buy, 2) ?
                                                            'Nuevo enlace' : 'Generar enlace' }}</button>
                                                <button
                                                    v-if="getContract(buy, 2) && hasActiveLink(getContract(buy, 2)) && !isContractSigned(getContract(buy, 2)) && getContract(buy, 2).latest_request.signature_url"
                                                    type="button" class="btn btn-outline-info btn-sm"
                                                    @click="viewContractLink(getContract(buy, 2))"><i
                                                        class="fa-solid fa-eye mr-1"></i> Ver enlace</button>
                                                <!-- Enviar enlace por correo -->
                                                <contract-email-button v-if="
                                                    getContract(buy, 2) &&
                                                    hasActiveLink(getContract(buy, 2)) &&
                                                    !isContractSigned(getContract(buy, 2)) &&
                                                    getContract(buy, 2).latest_request &&
                                                    getContract(buy, 2).latest_request.signature_url
                                                " :contract="getContract(buy, 2)" :source-type="2" :contract-type="2"
                                                    :provider-email="buy.user ? buy.user.email : ''"
                                                    @sent="list(page)" />
                                                <button v-if="hasUploadedContract(getContract(buy, 2))" type="button"
                                                    class="btn btn-outline-success btn-sm"
                                                    @click="viewUploadedContract(getContract(buy, 2))">
                                                    <i class="fa-solid fa-file-pdf mr-1"></i> Ver PDF recibido
                                                </button>

                                                <button v-if="canCancelReceivedContract(getContract(buy, 2))"
                                                    type="button"
                                                    class="btn btn-outline-danger btn-sm gm-contract-cancel-button"
                                                    @click="cancelReceivedContract(getContract(buy, 2))">
                                                    <i class="fa-solid fa-ban mr-1"></i>
                                                    {{ isContractSigned(getContract(buy, 2)) ? 'Cancelar firma' :
                                                        'Cancelar archivo' }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td align="center" colspan="7">Sin resultados.</td>
                            </tr>
                        </tbody>
                        <tfoot v-if="buys.total > 0 && load == false">
                            <tr class="table-secondary">
                                <td colspan="3">
                                    Total :
                                </td>
                                <td class="text-right">
                                    {{ sumdata()[0] | toCurrency }}
                                </td>
                                <td class="text-right">
                                    {{ sumdata()[1] | toCurrency }}
                                </td>
                                <td class="text-right">
                                    {{ sumdata()[2] | toCurrency }}
                                </td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                    <pagination v-model="page" :records="buys.total" :per-page="buys.per_page" @paginate="list" />
                </div>
            </section>
            <ModalTableComponent />
            <ModalBuysRelationComponent />
            <ModalFormComponentBuy />
            <ModalForm />
            <ModalBuyIncreasesComponent />
        </div>
    </div>
</template>
<script>
import ModalTableComponent from '@/components/checks/ModalTableComponent.vue';
import ModalBuysRelationComponent from '@/components/buy/ModalBuysRelationComponent.vue';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import Pagination from 'vue-pagination-2';
import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import ModalFormComponentBuy from '@/components/buy/ModalTableComponent.vue'
import ModalForm from '@/components/buy/ModalFormComponent.vue';
import ModalBuyIncreasesComponent from '@/components/buy/ModalBuyIncreasesComponent.vue';
import ContractEmailButton from '@/components/contracts/ContractEmailButton.vue';

export default {
    name: "companies-table",
    components: {
        ModalTableComponent,
        ModalBuysRelationComponent,
        ModalFormComponentBuy,
        Pagination,
        ModalForm,
        ModalBuyIncreasesComponent,
        ContractEmailButton
    },
    data() {
        return {
            name: '',
            idS: '',
            buys: {},
            search: {
                status: 1,
                search: '',
                id: '',
                building_id: '',
                company_id: '',
                user_id: '',
                concept_id: '',
                requires_contract: '',
                no_repse_required: '',
                has_overdue_payment: '',
                payment_period_id: [1, 2, 3, 4, 6, 7, 8, 9]
            },
            page: 1,
            load: false,
            catalogue: new Catalogue(),
        }
    },
    mounted() {
        this.list();
        this.catalogue.get_buildings();
        this.catalogue.get_companies_buildings();
        this.catalogue.get_users_profile(2);
        this.catalogue.get_concepts();
        this.setHeaderTitle('Gastos recurrentes');
    },
    created() {
        Event.$on("event-load-companies", () => {
            this.list();
        });
    },
    methods: {
        clearBuyFilters() {
            this.name = '';
            this.idS = '';
            Object.assign(this.search, {
                building_id: '', company_id: '', user_id: '', concept_id: '',
                requires_contract: '', no_repse_required: '', has_overdue_payment: ''
            });
            this.page = 1;
        },
        canCancelReceivedContract(contract) {
            if (!contract || !contract.id) return false;
            return this.isContractSigned(contract) || this.hasUploadedContract(contract);
        },
        async cancelReceivedContract(contract) {
            if (!this.canCancelReceivedContract(contract)) return;
            const isSignature = this.isContractSigned(contract);
            const typeName = isSignature ? 'firma electrónica' : 'archivo PDF';
            const result = await this.$swal.fire({
                title: `Cancelar ${typeName}`,
                html: `<p class="text-muted mb-1">El documento recibido dejará de estar vigente y podrás generar un nuevo enlace para el proveedor. El historial se conservará.</p>`,
                icon: 'warning',
                input: 'textarea',
                inputLabel: 'Motivo de cancelación',
                inputPlaceholder: 'Escribe por qué se cancela esta recepción',
                inputAttributes: { maxlength: 500 },
                showCancelButton: true,
                confirmButtonText: 'Confirmar cancelación',
                cancelButtonText: 'Volver',
                confirmButtonColor: '#c0392b',
                reverseButtons: true,
                inputValidator: value => {
                    if (!value || value.trim().length < 5) {
                        return 'Escribe un motivo de al menos 5 caracteres.';
                    }
                }
            });
            if (!result.isConfirmed) return;
            try {
                await request.post(`/budget-buy-contracts/${contract.id}/cancel-received`, {
                    reason: result.value.trim()
                });
                await this.$swal.fire({
                    icon: 'success',
                    title: 'Recepción cancelada',
                    text: 'Ahora puedes generar un nuevo enlace de firma.',
                    confirmButtonText: 'Entendido'
                });
                await this.list(this.page);
            } catch (error) {
                await this.$swal.fire({
                    icon: 'error',
                    title: 'No fue posible cancelar',
                    text: (error.response && error.response.data && error.response.data.message) ||
                        'Verifica el contrato e inténtalo de nuevo.'
                });
            }
        },
        shouldShowContract(buy, contractType) {
            if (!buy) return false;
            const enabled = Number(contractType) === 1
                ? buy.applies_to_service
                : buy.applies_to_work;
            return enabled === true || enabled === 1 || enabled === '1';
        },
        // El ID del contrato pertenece a budget_buy_contracts, no al presupuesto.
        viewSignedContract(contract) {
            if (!contract || !contract.id || !this.isContractSigned(contract)) return;
            const base = String(this.globalUrlFiles || '').replace(/\/$/, '');
            const url = `${base}/budget-buy-contracts/${encodeURIComponent(contract.id)}/signed-pdf`;
            window.open(url, '_blank', 'noopener,noreferrer');
        },
        uploadedContractFile(contract) {
            if (!contract) return null;
            return contract.uploaded_file || (contract.latest_request && contract.latest_request.uploaded_file) || null;
        },
        hasUploadedContract(contract) {
            const file = this.uploadedContractFile(contract);
            return !!(file && !file.cancelled_at);
        },
        viewUploadedContract(contract) {
            const file = this.uploadedContractFile(contract);
            if (!file || !file.id) return;
            // Esta URL requiere la ruta web autenticada descrita junto al archivo.
            const base = String(this.globalUrlFiles || '').replace(/\/$/, '');
            window.open(`${base}/budget-buy-contract-uploaded-files/${encodeURIComponent(file.id)}/pdf`, '_blank', 'noopener,noreferrer');
        },
        isContractSigned(contract) {
            if (!contract) return false;
            const signature = contract.latest_request && contract.latest_request.signature;
            return !!(signature && !signature.cancelled_at) ||
                ((contract.is_signed === true || contract.is_signed === 1 || contract.is_signed === '1') &&
                    !(signature && signature.cancelled_at));
        },
        signerForContract(contract) {
            if (!contract) return '';
            const signature = contract.latest_request && contract.latest_request.signature;
            return contract.signer_name || (signature && signature.signer_name) || '';
        },
        signedDateForContract(contract) {
            if (!contract) return null;
            const signature = contract.latest_request && contract.latest_request.signature;
            return contract.signed_at || (signature && signature.signed_at) || null;
        },
        contractStatusLabel(contract) {
            if (!contract) return 'Sin enlace';
            if (this.isContractSigned(contract)) return 'Firmado electrónicamente';
            if (this.hasUploadedContract(contract)) return 'PDF recibido';
            switch (Number(contract.status)) {
                case 1: return this.hasActiveLink(contract) ? 'Pendiente de firma' : 'Sin enlace vigente';
                case 2: return 'Pendiente de validación';
                case 3: return 'Contrato firmado';
                case 4: return 'Cancelado';
                default: return 'Estado no disponible';
            }
        },
        contractBadgeClass(contract) {
            if (this.isContractSigned(contract)) return 'badge badge-success';
            if (this.hasUploadedContract(contract)) return 'badge badge-success';
            if (!contract) return 'badge badge-light border';
            const status = Number(contract.status);
            if (status === 3) return 'badge badge-success';
            if (status === 2) return 'badge badge-info';
            if (status === 4) return 'badge badge-secondary';
            return 'badge badge-warning';
        },
        canGenerateContractLink(contract) {
            if (!contract) return true;
            if (this.isContractSigned(contract) || this.hasUploadedContract(contract)) return false;
            return this.needsNewLink(contract);
        },
        formatContractDate(value) {
            if (!value) return '';
            const date = new Date(value);
            return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString('es-MX');
        },
        viewContractLink(contract) {
            if (
                !contract ||
                !contract.latest_request
            ) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Enlace no disponible',
                    text: 'No se encontró un enlace activo para este contrato.'
                });
                return;
            }
            const signatureRequest =
                contract.latest_request;
            if (!signatureRequest.signature_url) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Enlace no disponible',
                    text: 'El enlace expiró o ya no se encuentra disponible.'
                });
                return;
            }
            this.showContractLink(
                signatureRequest.signature_url,
                signatureRequest.expires_at_formatted
            );
        },
        // |--------------------------------------------------------------------------
        // | CONTRATOS
        // |--------------------------------------------------------------------------
        // Obtiene el contrato correspondiente.
        // contractType:
        // 1 = Servicio
        // 2 = Obra
        getContract(item, contractType) {
            if (!item || !Array.isArray(item.budget_buy_contracts)) return null;
            const matching = item.budget_buy_contracts.filter(contract =>
                Number(contract.contract_type) === Number(contractType)
            );
            // Cada tipo conserva su propio registro; nunca depende del otro.
            return matching.find(contract => this.isContractSigned(contract) || this.hasUploadedContract(contract) || Number(contract.status) === 3)
                || matching.find(contract => Number(contract.status) !== 4)
                || matching[0]
                || null;
        },
        // Estados 1 y 2 representan solicitudes de firma vigentes.
        hasActiveLink(contract) {
            if (this.isContractSigned(contract) || this.hasUploadedContract(contract)) return false;
            if (
                !contract ||
                !contract.latest_request
            ) {
                return false;
            }
            var signatureRequest =
                contract.latest_request;
            var status =
                Number(signatureRequest.status);
            return (
                (status === 1 || status === 2) &&
                signatureRequest.is_expired === false
            );
        },
        // Determina si debe generarse un enlace nuevo.
        needsNewLink(contract) {
            if (this.isContractSigned(contract) || this.hasUploadedContract(contract)) return false;
            if (!contract) {
                return true;
            }
            // El contrato debe seguir pendiente
            // de firma del proveedor.
            // 1 = Pendiente firma proveedor
            if (
                Number(contract.status) !== 1
            ) {
                return false;
            }
            // Nunca se ha generado enlace.
            if (!contract.latest_request) {
                return true;
            }
            var signatureRequest =
                contract.latest_request;
            var status =
                Number(signatureRequest.status);
            // 4 = Expirado
            // 5 = Cancelado
            return (
                signatureRequest.is_expired ||
                status === 4 ||
                status === 5
            );
        },
        // Generar enlace de firma.
        // sourceType:
        // 1 = Budget
        // 2 = Buy
        // contractType:
        // 1 = Servicio
        // 2 = Obra
        async generateContractLink(
            item,
            contractType,
            sourceType
        ) {
            if (this.isContractSigned(this.getContract(item, contractType))) {
                await this.$swal.fire({
                    icon: 'info',
                    title: 'Firma ya registrada',
                    text: 'Este contrato ya cuenta con una firma y no admite otro enlace.'
                });
                return;
            }
            const contractName =
                Number(contractType) === 1
                    ? 'servicio'
                    : 'obra';
            const confirmation =
                await this.$swal.fire({
                    title: 'Generar enlace de firma',
                    html: `
                        <div class="text-left">
                            <p class="mb-3">
                                Se generará un enlace único para el
                                <strong>contrato de ${contractName}</strong>.
                            </p>
                            <div
                                class="
                                    alert
                                    alert-warning
                                    mb-3
                                "
                            >
                                <i
                                    class="
                                        fa-solid
                                        fa-clock
                                        mr-1
                                    "
                                ></i>
                                El enlace tendrá una vigencia de
                                <strong>3 días</strong>.
                            </div>
                            <p class="text-muted mb-0">
                                Podrás copiar el enlace y compartirlo
                                con el proveedor por WhatsApp,
                                correo electrónico o cualquier otro medio.
                            </p>
                        </div>
                    `,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText:
                        '<i class="fa-solid fa-link mr-1"></i> Generar enlace',
                    cancelButtonText:
                        'Cancelar',
                    confirmButtonColor:
                        '#3085d6',
                    cancelButtonColor:
                        '#6c757d'
                });
            if (!confirmation.isConfirmed) {
                return;
            }
            try {
                const { data } =
                    await request.post(
                        '/budget-buy-contracts/generate-link',
                        {
                            budget_buy_id:
                                item.id,
                            source_type:
                                sourceType,
                            contract_type:
                                contractType
                        }
                    );
                if (
                    !data ||
                    !data.data ||
                    !data.data.signature_url
                ) {
                    throw new Error(
                        'La API no regresó el enlace de firma.'
                    );
                }
                let expiresAt = '';
                if (
                    data.data.request &&
                    data.data.request.expires_at_formatted
                ) {
                    expiresAt =
                        data.data.request.expires_at_formatted;
                } else if (
                    data.data.expires_at_formatted
                ) {
                    // Compatibilidad por si la respuesta
                    // todavía utiliza la estructura anterior.
                    expiresAt =
                        data.data.expires_at_formatted;
                }
                await this.showContractLink(
                    data.data.signature_url,
                    expiresAt
                );
                // Recargar listado para obtener:
                // budget_buy_contracts
                // latest_request
                // statuses
                await this.list(this.page);
            } catch (error) {
                console.error(error);
                let message =
                    'No fue posible generar el enlace de firma.';
                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.message
                ) {
                    message =
                        error.response.data.message;
                } else if (
                    error.message
                ) {
                    message =
                        error.message;
                }
                this.$swal.fire({
                    icon: 'error',
                    title:
                        'No se pudo generar el enlace',
                    text:
                        message,
                    confirmButtonText:
                        'Aceptar'
                });
            }
        },
        // Mostrar enlace recién generado.
        // IMPORTANTE:
        // El token original no se almacena en BD,
        // por lo tanto éste es el momento para copiarlo.
        async showContractLink(signatureUrl, expiresAt) {
            const expirationHtml = expiresAt
                ? `
            <div class="gm-contract-expiration">
                <div class="gm-contract-expiration-icon">
                    <i class="fa-regular fa-clock"></i>
                </div>
                <div>
                    <span>Vigencia del enlace</span>
                    <strong>${expiresAt}</strong>
                </div>
            </div>
        `
                : '';
            const result = await this.$swal.fire({
                width: 590,
                padding: 0,
                showCloseButton: true,
                title: '',
                html: `
            <div class="gm-contract-modal">
                <!-- HEADER -->
                <div class="gm-contract-header">
                    <div class="gm-contract-header-icon">
                        <i class="fa-solid fa-link"></i>
                    </div>
                    <div class="gm-contract-header-info">
                        <h3>
                            Enlace de firma
                        </h3>
                        <p>
                            Comparte este acceso con el proveedor
                            responsable del contrato.
                        </p>
                    </div>
                </div>
                <!-- BODY -->
                <div class="gm-contract-body">
                    <!-- ESTADO -->
                    <div class="gm-contract-status">
                        <div class="gm-contract-status-icon">
                            <i class="fa-solid fa-check"></i>
                        </div>
                        <div>
                            <strong>
                                Enlace activo
                            </strong>
                            <span>
                                El acceso está listo para compartirse.
                            </span>
                        </div>
                    </div>
                    <!-- LINK -->
                    <div class="gm-contract-field">
                        <label>
                            Enlace para firma
                        </label>
                        <div class="gm-contract-input-container">
                            <i class="fa-solid fa-link"></i>
                            <input
                                id="contract-signature-url"
                                type="text"
                                readonly
                            >
                        </div>
                        <small>
                            El proveedor podrá abrir el contrato,
                            revisarlo y continuar con el proceso de firma.
                        </small>
                    </div>
                    <!-- VIGENCIA -->
                    ${expirationHtml}
                    <!-- COMPARTIR -->
                    <div class="gm-contract-info">
                        <div class="gm-contract-info-icon">
                            <i class="fa-solid fa-share-nodes"></i>
                        </div>
                        <div>
                            <strong>
                                Compartir enlace
                            </strong>
                            <span>
                                Puedes enviarlo por WhatsApp, correo
                                electrónico o cualquier otro medio autorizado.
                            </span>
                        </div>
                    </div>
                    <!-- SEGURIDAD -->
                    <div class="gm-contract-security">
                        <i class="fa-solid fa-shield-halved"></i>
                        <span>
                            Enlace único para este proceso contractual.
                            Evita compartirlo con personas ajenas.
                        </span>
                    </div>
                </div>
            </div>
        `,
                showCancelButton: true,
                showDenyButton: true,
                buttonsStyling: false,
                confirmButtonText: `
            <i class="fa-solid fa-copy mr-1"></i>
            Copiar enlace
        `,
                denyButtonText: `
            <i class="fa-solid fa-arrow-up-right-from-square mr-1"></i>
            Abrir enlace
        `,
                cancelButtonText: 'Cerrar',
                focusConfirm: false,
                customClass: {
                    popup: 'gm-contract-popup',
                    htmlContainer: 'gm-contract-html',
                    actions: 'gm-contract-actions',
                    confirmButton: 'gm-contract-btn gm-contract-btn-primary',
                    denyButton: 'gm-contract-btn gm-contract-btn-outline-info',
                    cancelButton: 'gm-contract-btn gm-contract-btn-outline',
                    closeButton: 'gm-contract-close'
                },
                didOpen: () => {
                    const input =
                        document.getElementById(
                            'contract-signature-url'
                        );
                    if (input) {
                        input.value = signatureUrl;
                        input.addEventListener(
                            'click',
                            function () {
                                this.select();
                            }
                        );
                    }
                },
                preConfirm: async () => {
                    const copied =
                        await this.copyContractLink(
                            signatureUrl
                        );
                    if (!copied) {
                        return false;
                    }
                    return true;
                }
            });
            if (result.isDenied) {
                window.open(
                    signatureUrl,
                    '_blank',
                    'noopener,noreferrer'
                );
                return;
            }
            if (result.isConfirmed) {
                this.$swal.fire({
                    icon: 'success',
                    title: 'Enlace copiado',
                    text:
                        'Ya puedes compartirlo con el proveedor.',
                    timer: 1400,
                    showConfirmButton: false
                });
            }
        },
        // Copiar URL al portapapeles.
        // navigator.clipboard requiere HTTPS.
        // document.execCommand funciona como fallback.
        async copyContractLink(url) {
            try {
                if (
                    navigator.clipboard &&
                    window.isSecureContext
                ) {
                    await navigator.clipboard.writeText(
                        url
                    );
                    return true;
                }
                const textarea =
                    document.createElement(
                        'textarea'
                    );
                textarea.value =
                    url;
                textarea.style.position =
                    'fixed';
                textarea.style.left =
                    '-999999px';
                textarea.style.top =
                    '-999999px';
                document.body.appendChild(
                    textarea
                );
                textarea.focus();
                textarea.select();
                const copied =
                    document.execCommand(
                        'copy'
                    );
                document.body.removeChild(
                    textarea
                );
                if (!copied) {
                    throw new Error(
                        'No fue posible copiar el enlace.'
                    );
                }
                return true;
            } catch (error) {
                console.error(error);
                this.$swal.showValidationMessage(
                    'No fue posible copiar automáticamente. Selecciona y copia el enlace manualmente.'
                );
                return false;
            }
        },
        // |--------------------------------------------------------------------------
        // | PDF PRESUPUESTO
        // |--------------------------------------------------------------------------
        shouldShowAuthorizeButton(contract) {
            const userId = this.authUser.id;
            const validator = contract.users_approved.find(v =>
                v.user_id === userId
            );
            return !validator;
        },
        showIncreases(buy) {
            Event.$emit('event-show-addBuyIncreases', buy);
        },
        changeStatus: function (buy) {
            let tit = buy.status == 1 ? 'Termina compra' : 'Activar compra';
            let txt = buy.status == 1 ? 'Seguro que quiere termina la compra' : 'Seguro que quiere activar la compra';
            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let _endpoint = '/buy_status?id=' + buy.id;
                    try {
                        let response = await request.post(_endpoint).then(function (response) { return response; });
                        this.list();
                        this.successNotification(response.data.message);
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },
        editBuy(buy = {}) {
            Event.$emit('event-show-addBuyModal', buy);
        },
        createFrom(buy) {
            Event.$emit('event-show-createFrom', buy);
        },
        sumdata() {
            let vm = this;
            let sum1 = 0;
            let sum2 = 0;
            let sum3 = 0;
            if (this.buys) {
                this.buys.data.forEach(function (buy) {
                    sum1 += parseFloat(buy.amount);
                    sum2 += vm.paysCheks(buy.checks);
                    sum3 += parseFloat(buy.amount) - vm.paysCheks(buy.checks);
                });
            }
            return [sum1, sum2, sum3];
        },
        viewPay(id) {
            Event.$emit('event-load-buy', id);
        },
        showBuysRelation(buy) {
            Event.$emit('event-show-BuysRelation', buy);
        },
        exportData() {
            let filter = this.globalUrlFiles + '/buys/export?' + new URLSearchParams(this.search).toString();
            filter += '&user_login=' + this.authUser.id;
            window.open(filter, '_blank');
        },
        showCheck(checks) {
            Event.$emit('event-show-listChecks', checks);
        },
        paysCheks(checks) {
            let sum = 0;
            // console.log(checks);
            checks.forEach((s) => {
                s.pay.forEach((b) => {
                    if (b.amount) {
                        sum += parseFloat(b.amount);
                    }
                });
            });
            return sum;
        },
        deleted: function (id) {
            let tit = 'Eliminar empresa';
            let txt = 'Seguro que quiere eliminar la empresa';
            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.callDeleted(id);
                }
            });
        },
        approve: function (id) {
            let tit = 'Aprobar gasto recurrente';
            let txt = 'Seguro que quiere aprobar el gasto recurrente';
            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let _endpoint = '/buy_validators';
                    let form = {
                        id: id
                    };
                    try {
                        let response = await request.post(_endpoint, form).then(function (response) { return response; });
                        this.list();
                        this.successNotification(response.data.message);
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },
        async callDeleted(id) {
            let _endpoint = '/buys/' + id;
            try {
                let response = await request.destroy(_endpoint).then(function (response) { return response; });
                this.list();
                this.successNotification(response.data.message);
            } catch (error) {
                this.errors = await this.errorNotification(error)
            }
        },
        showImport() {
            this.$modal.show('example');
        },
        async list(page = 1) {
            this.load = true;
            let service = request;
            let search = this.search;
            search.search = this.name;
            search.id = this.idS;
            let _endpoint = '/buys';
            try {
                let { data } = await service.list(_endpoint, page, search)
                if (data) {
                    this.buys = data;
                    this.load = false;
                }
            } catch (error) {
                console.log(error);
                this.load = false;
            }
        },
        ...mapMutations({
            setHeaderTitle: 'setHeaderTitle',
        }),
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    computed: {
        buyPageRows() {
            return Array.isArray(this.buys.data) ? this.buys.data : [];
        },
        buyPageAmount() {
            return this.buyPageRows.reduce((sum, buy) => sum + (Number(buy.amount) || 0), 0);
        },
        buyPageReceivedContracts() {
            return this.buyPageRows.reduce((total, buy) => {
                return total + [1, 2].filter(type => {
                    if (!this.shouldShowContract(buy, type)) return false;
                    const contract = this.getContract(buy, type);
                    return this.isContractSigned(contract) || this.hasUploadedContract(contract);
                }).length;
            }, 0);
        },
        buyPageActiveLinks() {
            return this.buyPageRows.reduce((total, buy) => {
                return total + [1, 2].filter(type =>
                    this.shouldShowContract(buy, type) && this.hasActiveLink(this.getContract(buy, type))
                ).length;
            }, 0);
        },
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
    watch: {
        'search': {
            handler: function () {
                this.list();
            },
            deep: true
        }
    },
}
</script>
<style>
.pagination {
    margin-bottom: 0;
}

.bg-success {
    background-color: #28a745 !important;
}

.bg-primary {
    background-color: #17a2b8 !important;
}

.gm-contract-popup {
    padding: 0 !important;
    overflow: hidden !important;
    border-radius: 8px !important;
    box-shadow:
        0 12px 35px rgba(0, 0, 0, .18) !important;
}

.gm-contract-html {
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
}

.gm-contract-header {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: #ffffff;
    border-bottom: 1px solid #e5e8eb;
}

.gm-contract-header-icon {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 13px;
    border-radius: 6px;
    background: #001f3f;
    color: #ffffff;
    font-size: 16px;
}

.gm-contract-header-info {
    min-width: 0;
    text-align: left;
}

.gm-contract-header-info h3 {
    margin: 0 0 3px;
    color: #343a40;
    font-size: 18px;
    line-height: 1.2;
    font-weight: 600;
}

.gm-contract-header-info p {
    margin: 0;
    color: #6c757d;
    font-size: 12px;
    line-height: 1.4;
}

.gm-contract-body {
    padding: 22px 24px 18px;
    text-align: left;
    background: #ffffff;
}

.gm-contract-status {
    display: flex;
    align-items: center;
    padding: 12px 14px;
    margin-bottom: 20px;
    border: 1px solid #cce7d4;
    border-radius: 6px;
    background: #f1faf4;
}

.gm-contract-status-icon {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
    border-radius: 50%;
    background: #28a745;
    color: #ffffff;
    font-size: 12px;
}

.gm-contract-status strong {
    display: block;
    margin-bottom: 1px;
    color: #28753b;
    font-size: 13px;
    font-weight: 600;
}

.gm-contract-status span {
    display: block;
    color: #5c7462;
    font-size: 11px;
}

.gm-contract-field {
    margin-bottom: 18px;
}

.gm-contract-field label {
    display: block;
    margin-bottom: 6px;
    color: #343a40;
    font-size: 12px;
    font-weight: 600;
}

.gm-contract-input-container {
    position: relative;
    display: flex;
    align-items: center;
}

.gm-contract-input-container>i {
    position: absolute;
    left: 13px;
    color: #73808c;
    font-size: 12px;
    pointer-events: none;
}

.gm-contract-input-container input {
    width: 100%;
    height: 42px;
    padding: 0 12px 0 37px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #f8f9fa;
    color: #495057;
    font-size: 12px;
    outline: none;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.gm-contract-input-container input:focus {
    background: #ffffff;
    border-color: #80bdff;
    box-shadow:
        0 0 0 .15rem rgba(0, 123, 255, .12);
}

.gm-contract-field small {
    display: block;
    margin-top: 6px;
    color: #7b8791;
    font-size: 10.5px;
    line-height: 1.4;
}

.gm-contract-expiration {
    display: flex;
    align-items: center;
    padding: 11px 13px;
    margin-bottom: 14px;
    border: 1px solid #ffe29a;
    border-radius: 6px;
    background: #fff9e6;
}

.gm-contract-expiration-icon {
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
    border-radius: 5px;
    background: #ffc107;
    color: #ffffff;
    font-size: 13px;
}

.gm-contract-expiration span {
    display: block;
    margin-bottom: 1px;
    color: #856404;
    font-size: 10.5px;
}

.gm-contract-expiration strong {
    display: block;
    color: #6b5200;
    font-size: 13px;
    font-weight: 600;
}

.gm-contract-info {
    display: flex;
    align-items: center;
    padding: 11px 13px;
    border: 1px solid #d6e6ed;
    border-radius: 6px;
    background: #f4fafc;
}

.gm-contract-info-icon {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
    color: #17a2b8;
    font-size: 14px;
}

.gm-contract-info strong {
    display: block;
    margin-bottom: 2px;
    color: #3d5964;
    font-size: 12px;
}

.gm-contract-info span {
    display: block;
    color: #71858d;
    font-size: 10.5px;
    line-height: 1.4;
}

.gm-contract-security {
    display: flex;
    align-items: center;
    margin-top: 15px;
    padding-top: 13px;
    border-top: 1px solid #edf0f2;
    color: #6c757d;
    font-size: 10.5px;
    line-height: 1.4;
}

.gm-contract-security i {
    margin-right: 8px;
    color: #001f3f;
    font-size: 12px;
}

.gm-contract-actions {
    width: 100% !important;
    display: flex !important;
    justify-content: flex-end !important;
    gap: 7px;
    margin: 0 !important;
    padding: 14px 24px 17px !important;
    border-top: 1px solid #e5e8eb;
    background: #f8f9fa;
}

.gm-contract-btn {
    min-width: 105px;
    margin: 0 !important;
    padding: 8px 14px !important;
    border-radius: 4px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    cursor: pointer;
}

.gm-contract-btn-primary {
    border: 1px solid #001f3f !important;
    background: #001f3f !important;
    color: #ffffff !important;
}

.gm-contract-btn-primary:hover {
    border-color: #00172f !important;
    background: #00172f !important;
}

.gm-contract-btn-outline-info {
    border: 1px solid #17a2b8 !important;
    background: #ffffff !important;
    color: #138496 !important;
}

.gm-contract-btn-outline-info:hover {
    background: #17a2b8 !important;
    color: #ffffff !important;
}

.gm-contract-btn-outline {
    border: 1px solid #adb5bd !important;
    background: #ffffff !important;
    color: #5f6972 !important;
}

.gm-contract-btn-outline:hover {
    background: #e9ecef !important;
}

.gm-contract-close {
    top: 8px !important;
    right: 9px !important;
    width: 30px !important;
    height: 30px !important;
    color: #adb5bd !important;
    font-size: 22px !important;
    line-height: 30px !important;
}

.gm-contract-close:hover {
    color: #495057 !important;
}

@media (max-width: 576px) {
    .gm-contract-popup {
        width: calc(100% - 20px) !important;
    }

    .gm-contract-header {
        padding: 17px;
    }

    .gm-contract-body {
        padding: 18px 17px 15px;
    }

    .gm-contract-header-icon {
        width: 38px;
        height: 38px;
        flex-basis: 38px;
    }

    .gm-contract-header-info h3 {
        font-size: 16px;
    }

    .gm-contract-header-info p {
        padding-right: 15px;
        font-size: 11px;
    }

    .gm-contract-actions {
        flex-direction: column;
        padding: 13px 17px 16px !important;
    }

    .gm-contract-btn {
        width: 100%;
    }
}

.pagination {
    margin-bottom: 0;
}

/* Tarjetas de contratos: servicio y obra se muestran por separado. */
.gm-contract-list {
    display: grid;
    gap: 12px;
    margin-top: 14px;
    text-align: left;
}

.gm-contract-item {
    padding: 15px;
    border: 1px solid #dce5ee;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 31, 63, .035);
    transition: border-color .2s ease, box-shadow .2s ease;
}

.gm-contract-item:hover {
    border-color: #b4c6da;
    box-shadow: 0 5px 20px rgba(0, 31, 63, .07);
}

.gm-contract-item__head {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.gm-contract-item__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 38px;
    height: 38px;
    background: #edf3f9;
    color: #001f3f;
    border-radius: 9px;
}

.gm-contract-item__name {
    display: flex;
    flex: 1 1 130px;
    flex-direction: column;
    min-width: 0;
    line-height: 1.4;
}

.gm-contract-item__name strong {
    font-size: 13px;
    color: #24364a;
}

.gm-contract-item__name small {
    font-size: 11px;
    color: #718096;
}

.gm-contract-item__head>.badge {
    margin-left: auto;
    padding: 7px 10px;
    font-size: 10px;
    line-height: 1.35;
    white-space: normal;
}

.gm-contract-item__signed {
    margin-top: 12px;
    padding: 10px 12px;
    border: 1px solid #d3eadb;
    border-radius: 8px;
    background: #effaf3;
    color: #22663b;
    font-size: 12px;
}

.gm-contract-item__signed small {
    display: block;
    margin-top: 3px;
    color: #47775a;
}

.gm-contract-item__actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
}

.gm-contract-item__actions .btn {
    margin: 0;
    padding: 7px 10px;
    font-size: 11px;
    line-height: 1.4;
    white-space: normal;
    border-radius: 6px;
}

@media (max-width: 576px) {
    .gm-contract-item {
        padding: 12px;
    }

    .gm-contract-item__head>.badge {
        margin-left: 0;
    }

    .gm-contract-item__actions .btn {
        flex: 1 1 auto;
    }
}

/* Contrato firmado manualmente: registro recibido para validación. */
.gm-contract-item__received {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
    padding: 11px;
    border: 1px solid #c9e6dc;
    border-radius: 9px;
    background: #f2faf7;
    text-align: left;
}

.gm-contract-item__received-icon {
    display: grid;
    place-items: center;
    flex: 0 0 36px;
    height: 36px;
    background: #dff2e9;
    color: #16704c;
    border-radius: 9px;
}

.gm-contract-item__received-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    line-height: 1.4;
}

.gm-contract-item__received-body strong {
    color: #1b6047;
    font-size: 12px;
}

.gm-contract-item__received-body span {
    overflow-wrap: anywhere;
    color: #244b3d;
    font-size: 11px;
}

.gm-contract-item__received-body small {
    color: #5e786d;
    font-size: 10px;
    margin-top: 3px;
}

.gm-contract-item__review-label {
    flex-shrink: 0;
    padding: 5px 8px;
    color: #86600a;
    background: #fff5db;
    border: 1px solid #f6e2a4;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 600;
}

@media (max-width: 576px) {
    .gm-contract-item__received {
        flex-wrap: wrap;
    }

    .gm-contract-item__review-label {
        margin-left: 46px;
    }
}

/* Rediseño premium: Gastos recurrentes */
.gm-buy-page {
    padding: 14px 16px 28px;
    color: #334155;
}

.gm-buy-titlebar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
}

.gm-buy-title {
    display: flex;
    gap: 12px;
    align-items: center;
    min-width: 0;
}

.gm-buy-title-icon {
    color: #243b53;
    font-size: 19px;
}

.gm-buy-title h2 {
    font-size: 20px;
    line-height: 1.2;
    margin: 0 0 4px;
    font-weight: 700;
    color: #263340;
}

.gm-buy-title p,
.gm-buy-results-head p {
    margin: 0;
    color: #80909c;
    font-size: 12px;
}

.gm-buy-title-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.gm-buy-title-actions .btn {
    border-radius: 8px;
    font-weight: 600;
    padding: 8px 11px;
}

.gm-buy-filters {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 17px 18px 14px;
    margin-bottom: 14px;
}

.gm-buy-section-label {
    font-size: 13px;
    font-weight: 700;
    color: #334155;
    margin-bottom: 13px;
}

.gm-filter-col {
    margin-bottom: 13px;
}

.gm-filter-col label {
    display: block;
    margin-bottom: 5px;
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
}

.gm-filter-col .form-control {
    height: 36px;
    font-size: 12px;
    border-radius: 7px;
    border-color: #dbe3ea;
    box-shadow: none;
}

.gm-filter-col .form-control:focus {
    border-color: #7195c5;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, .09);
}

.gm-buy-quick-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding-top: 12px;
    border-top: 1px solid #e7edf3;
}

.gm-buy-chip {
    border: 1px solid #dbe3ea;
    background: white;
    color: #64748b;
    border-radius: 7px;
    padding: 8px 12px;
    font-size: 11px;
    font-weight: 600;
    transition: all .18s ease;
}

.gm-buy-chip i {
    margin-right: 5px;
}

.gm-buy-chip:hover,
.gm-buy-chip.is-active {
    border-color: #91b8ee;
    color: #1d4ed8;
    background: #eff6ff;
}

.gm-buy-clear {
    border: 0;
    background: transparent;
    color: #64748b;
    padding: 8px 10px;
    font-size: 11px;
    margin-left: auto;
}

.gm-buy-clear:hover {
    color: #1d4ed8;
}

.gm-buy-stats {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
}

.gm-buy-stat {
    min-width: 0;
    display: flex;
    gap: 12px;
    align-items: center;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-left: 3px solid #718096;
    border-radius: 9px;
    padding: 13px 15px;
    box-shadow: 0 2px 8px rgba(15, 23, 42, .025);
}

.gm-buy-stat__icon {
    display: grid;
    place-items: center;
    flex: 0 0 38px;
    height: 38px;
    border-radius: 50%;
    background: #f1f5f9;
    color: #475569;
}

.gm-buy-stat small {
    display: block;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .35px;
    color: #82909c;
}

.gm-buy-stat strong {
    display: block;
    color: #202b38;
    font-size: 20px;
    line-height: 1.22;
    font-weight: 750;
    overflow-wrap: anywhere;
}

.gm-buy-stat--green {
    border-left-color: #16a34a;
}

.gm-buy-stat--green .gm-buy-stat__icon {
    color: #16a34a;
    background: #ecfdf3;
}

.gm-buy-stat--amber {
    border-left-color: #f59e0b;
}

.gm-buy-stat--amber .gm-buy-stat__icon {
    color: #d97706;
    background: #fffbeb;
}

.gm-buy-stat--blue {
    border-left-color: #4f7bec;
}

.gm-buy-stat--blue .gm-buy-stat__icon {
    color: #4f7bec;
    background: #eff6ff;
}

.gm-buy-stats-note {
    font-size: 10px;
    color: #94a3b8;
    text-align: right;
    margin: 5px 0 13px;
}

.gm-buy-results {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
}

.gm-buy-results-head {
    padding: 14px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.gm-buy-results-head h3 {
    margin: 0 0 4px;
    font-size: 15px;
    font-weight: 700;
    color: #334155;
}

.gm-buy-segment {
    display: flex;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 8px;
    flex-shrink: 0;
}

.gm-buy-segment button {
    padding: 7px 13px;
    border: 0;
    background: transparent;
    color: #64748b;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 650;
}

.gm-buy-segment button.active {
    background: white;
    color: #1d4ed8;
    box-shadow: 0 1px 4px rgba(15, 23, 42, .12);
}

.gm-buy-results .table-responsive {
    margin: 0;
}

.gm-buy-table {
    margin-bottom: 0;
    font-size: 11px;
    border-left: 0;
    border-right: 0;
}

.gm-buy-table thead th {
    background: #f1f5f9;
    color: #475569;
    border-color: #e2e8f0;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: .3px;
    vertical-align: middle;
    padding: 12px 10px;
}

.gm-buy-table tbody td {
    vertical-align: middle;
    border-color: #edf1f5;
    padding: 13px 10px;
    line-height: 1.65;
}

.gm-buy-table tbody tr:hover td {
    background: #f8fafc;
}

.gm-buy-table tbody td:nth-child(2) {
    min-width: 275px;
}

.gm-buy-table tbody td:last-child {
    min-width: 280px;
}

.gm-buy-table .btn {
    border-radius: 7px;
    font-size: 11px;
}

.gm-buy-page .gm-contract-item {
    border-radius: 9px;
    background: #fff;
    box-shadow: none;
}

.gm-buy-page .gm-contract-item__actions .gm-contract-cancel-button {
    border-color: #efc5c5;
    color: #bd3030;
    background: #fff;
}

.gm-buy-page .gm-contract-item__actions .gm-contract-cancel-button:hover {
    background: #dc3545;
    color: #fff;
    border-color: #dc3545;
}

.gm-buy-page .gm-contract-item__actions {
    gap: 6px;
}

@media(max-width:1100px) {
    .gm-buy-stats {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media(max-width:600px) {
    .gm-buy-page {
        padding: 12px 8px;
    }

    .gm-buy-titlebar,
    .gm-buy-results-head {
        flex-direction: column;
        align-items: stretch;
    }

    .gm-buy-title-actions .btn {
        flex: 1 1 auto;
    }

    .gm-buy-stats {
        gap: 8px;
    }

    .gm-buy-stat {
        padding: 10px;
        gap: 8px;
    }

    .gm-buy-stat__icon {
        flex-basis: 31px;
        height: 31px;
    }

    .gm-buy-stat strong {
        font-size: 16px;
    }

    .gm-buy-stat small {
        font-size: 9px;
    }

    .gm-buy-filters {
        padding: 14px 12px;
    }

    .gm-buy-clear {
        margin-left: 0;
    }
}
</style>
